//See EnvConfigurationService for dynamic configuration
export const environment = {
  production: true,
  mockAuth: false,
  version: '0.0.1',
  clientId: 'PROD-B2B',
  redirectUri: 'https://bibnetads-prod.michelin.com/b2b/portal',
  wellKnown: 'https://login-fed.michelin.com/am/oauth2/.well-known/openid-configuration',
  apiBase: 'https://bibnetads-prod.michelin.com/b2b/api/portal',
  apiBaseAuth: 'https://bibnetads-prod.michelin.com/k8s/api/auth/api',
  keyToken: 'TOKEN_JWT',
  authTxnApiKey: '',
  authTxnApiSecret: ''
};
